import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import classes from "./styles/style.module.css";
import { setShowWordGameHintModal } from "../../../assets/redux/actions/Quiz";
import WordGameHintDialog from "../alertContents/WordGameHintDialog";
import { useNavigate } from "react-router-dom";
import {
  createWordGameTicket,
  createWordGameTicketUsingKey,
  getWordGameTodayCount,
} from "../../../assets/services/apiServices";
import errorHandler from "../../../assets/utils/ErrorHandler";
import Loading from "../../../assets/containers/loadingDialog";
import StartWithKeyDialog from "./StartWithKeyDialog";

const WordGamePreview = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [showStartWithKeyDialog, setShowStartWithKeyDialog] = useState(false);

  useEffect(() => {
    fetchTotalCount();
  }, []);

  const fetchTotalCount = async () => {
    try {
      const response = await getWordGameTodayCount();
      setTotalCount(response.data);
    } catch (err) {
      errorHandler(err);
    }
  };

  const handleStartGame = async () => {
    setLoading(true);
    try {
      const response = await createWordGameTicket();
      const matchId = response.data.createdTicket._id;
      navigate(`/wordGame/${matchId}`);
    } catch (err) {
      errorHandler(err);
    } finally {
      setLoading(false);
    }
  };

  const handleStartGameUsingKey = async () => {
    setLoading(true);
    try {
      const response = await createWordGameTicketUsingKey();
      const matchId = response.data.createdTicket._id;
      navigate(`/wordGame/${matchId}`);
    } catch (err) {
      errorHandler(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        <div className="d-flex justify-content-between align-items-center mt-3">
          <p>تعداد تلاش رایگان روزانه: </p>
          <p>
            {totalCount?.todayCount}/{totalCount?.total}
          </p>
        </div>
        <img
          src="/images/wordGame/wordGamePoster.png"
          className="img-fluid w-100 mt-2 mb-3"
          alt="wordGamePreview"
        />
        <div>
          {!loading ? (
            <button
              className={`${classes.wordGameButton} ${classes.purplueButton}`}
              onClick={handleStartGame}
            >
              شروع چالش
            </button>
          ) : (
            <div className="d-flex justify-content-center">
              <Loading />
            </div>
          )}
          <br />
          <br />
          <button
            className={`${classes.wordGameButton} ${classes.orangeButton}`}
            onClick={() => setShowStartWithKeyDialog(true)}
          >
            شروع به ازای 3 کلید
          </button>
          <br />
          <br />
          <button
            className={`${classes.wordGameButton} ${classes.greenButton}`}
            onClick={() => dispatch(setShowWordGameHintModal(true))}
          >
            راهنمایی
          </button>
        </div>
      </div>
      <WordGameHintDialog />
      <StartWithKeyDialog
        open={showStartWithKeyDialog}
        handleClose={() => setShowStartWithKeyDialog(false)}
        handleSubmit={handleStartGameUsingKey}
      />
    </AnimatedPageContainer>
  );
};

export default WordGamePreview;
